<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="650px"
  >
    <v-card
      class="dialog-modelos-card"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
        flat
      >
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="cancelar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="pt-1 pb-0 pa-5 dialog-modelos-card-text"
      >
        <v-container
          v-show="edit"
          fluid
          class="pt-4 pb-3 pa-0"
        >
          <v-row
            dense
            align="center"
          >
            <v-col
              cols="auto"
              class="mb-2 mb-sm-0 d-flex"
            >
              <v-btn
                icon
                @click="showInfo"
              >
                <v-icon
                  large
                >
                  mdi-information-outline
                </v-icon>
              </v-btn>
            </v-col>
            <v-col
              class="mb-2 mb-sm-0 d-flex"
            >
              <v-btn
                class="btn-dialog-redondeado flex-grow-1 mr-2"
                outlined
                @click="onClickCargar"
              >
                Cargar modelos
              </v-btn>
              <input
                ref="fileInput"
                type="file"
                accept=".txt"
                style="display:none"
                @change="onChangeArchivo"
              >
              <v-btn
                class="btn-dialog-redondeado flex-grow-1"
                outlined
                @click="exportarModelos"
              >
                Exportar modelos
                <v-icon
                  small
                  class="pl-2"
                >
                  mdi-tray-arrow-down
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-4"
            align="center"
          >
            <v-col>
              <v-autocomplete
                v-model="perfilSeleccionado"
                :items="perfiles"
                label="Cargas de combustible"
                dense
                outlined
                disabled
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div
        class="modelos-table-wrapper"
      >
        <div
          class="modelos-columns-header grid-layout"
        >
          <div
            class="col-header text-center pr-1"
          >
            Modelo
          </div>

          <div
            v-for="col in columnasValores"
            :key="col.key"
            class="col-header text-center"
          >
            {{ col.label }}
          </div>

          <div
            v-show="edit"
            class="col-header text-center"
          >
            <v-btn
              icon
              x-small
              outlined
              color="primary"
              @click="addFila"
            >
              <v-icon
                small
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-data-table
          ref="tablaModelos"
          :headers="headersModelos"
          :items="filasLocal"
          item-key="FUEL_MODEL_TYPE"
          dense
          hide-default-header
          fixed-header
          height="420"
          hide-default-footer
          disable-pagination
          class="modelos-data-table"
        >
          <template
            #item="{ item, index }"
          >
            <tr
              class="grid-layout"
            >
              <td
                class="pa-1"
              >
                <v-text-field
                  v-model="item.FUEL_MODEL_TYPE"
                  dense
                  outlined
                  hide-details
                  disabled
                  class="campo-modelo text-right"
                />
              </td>

              <td
                v-for="col in columnasValores"
                :key="col.key"
                class="pa-1"
              >
                <v-text-field
                  v-model="item[col.key]"
                  dense
                  outlined
                  hide-details
                  type="number"
                  :error="item[col.key] === '' || item[col.key] === null"
                  class="campo-modelo text-right"
                />
              </td>

              <td
                class="d-flex justify-center align-center"
              >
                <v-btn
                  v-if="item.custom"
                  icon
                  small
                  color="grey darken-1"
                  @click="borrarFila(index)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <div
        class="modelos-footer-fixed"
      >
        <div
          class="d-flex w-100"
        >
          <v-btn
            class="btn-dialog-redondeado btn-equal-width mr-2"
            outlined
            :disabled="!hayCambios"
            @click="resetValores"
          >
            Valores por defecto
            <v-icon
              small
              class="pl-2"
            >
              mdi-arrow-u-left-top
            </v-icon>
          </v-btn>

          <v-btn
            class="btn-dialog-redondeado btn-equal-width ml-2"
            color="primary"
            dark
            @click="aceptar"
          >
            Aplicar
            <v-icon
              small
              class="pl-2"
            >
              mdi-check
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>

    <vx-info-modelos
      class="mt-4"
      :show="showDialogInfo"
      @cerrar="cerrarInfo"
    />
  </v-dialog>
</template>

<script>
import InfoModelos from './InfoModelos.vue'

export default {
  components: {
    'vx-info-modelos': InfoModelos
  },

  props: {
    show: Boolean,
    edit: Boolean,
    filas: Array
  },

  data () {
    return {
      perfiles: ['Weather Map Site (Predeterminado)'],
      perfilSeleccionado: null,
      filasLocal: [],
      filasSnapshot: [],
      columnasValores: [
        { key: 'H1', label: '1h' },
        { key: 'H10', label: '10h' },
        { key: 'H100', label: '100h' },
        { key: 'LIVE_H', label: 'FLH' },
        { key: 'LIVE_W', label: 'FLW' }
      ],

      showDialogInfo: false
    }
  },

  computed: {
    titulo () {
      return this.edit ? 'Modificar carga de modelos de combustible' : 'Modificar humedad de modelos de combustible'
    },
    headersModelos () {
      const base = [{ text: 'Modelo', value: 'FUEL_MODEL_TYPE' }]
      const cols = this.columnasValores.map(col => ({ text: col.label, value: col.key }))
      return [...base, ...cols, { text: '', value: 'actions' }]
    },

    hayCambios () {
      return JSON.stringify(this.filasLocal) !== JSON.stringify(this.filasSnapshot)
    }
  },

  watch: {
    show () {
      this.initFromProps()
    }
  },

  mounted () {
    this.perfilSeleccionado = this.perfiles[0]
  },

  methods: {
    initFromProps () {
      let datosNormalizados = []

      const defaultValue = 0

      if (this.filas && this.filas.length > 0) {
        datosNormalizados = this.filas.map((f, idx) => {
          let h1Val, h10Val, h100Val, flhVal, flwVal, modeloVal
          if (this.edit) {
            h1Val = f.H1 !== undefined && f.H1 !== null ? parseFloat(f.H1) : defaultValue
            h10Val = f.H10 !== undefined && f.H10 !== null ? parseFloat(f.H10) : defaultValue
            h100Val = f.H100 !== undefined && f.H100 !== null ? parseFloat(f.H100) : defaultValue
            flhVal = f.LIVE_H !== undefined && f.LIVE_H !== null ? parseFloat(f.LIVE_H) : defaultValue
            flwVal = f.LIVE_W !== undefined && f.LIVE_W !== null ? parseFloat(f.LIVE_W) : defaultValue
            modeloVal = f.FUEL_MODEL_TYPE !== undefined && f.FUEL_MODEL_TYPE !== null ? parseInt(f.FUEL_MODEL_TYPE) : idx
          } else {
            h1Val = f.humidity !== undefined && f.humidity !== null ? parseFloat(f.humidity) : defaultValue
            h10Val = f.humidity10h !== undefined && f.humidity10h !== null ? parseFloat(f.humidity10h) : defaultValue
            h100Val = f.humidity100h !== undefined && f.humidity100h !== null ? parseFloat(f.humidity100h) : defaultValue
            flhVal = f.FLH !== undefined && f.FLH !== null ? parseFloat(f.FLH) : defaultValue
            flwVal = f.FLW !== undefined && f.FLW !== null ? parseFloat(f.FLW) : defaultValue
            modeloVal = f.model !== undefined && f.model !== null ? parseInt(f.model) : idx
          }

          const customVal = f.custom !== undefined ? f.custom : (modeloVal > 13)

          return {
            custom: customVal,
            FUEL_MODEL_TYPE: modeloVal,
            H1: h1Val,
            H10: h10Val,
            H100: h100Val,
            LIVE_H: flhVal,
            LIVE_W: flwVal
          }
        })
      } else {
        datosNormalizados = Array.from({ length: 14 }, (_, i) => ({
          custom: false,
          FUEL_MODEL_TYPE: i,
          H1: 0,
          H10: 0,
          H100: 0,
          LIVE_H: 0,
          LIVE_W: 0
        }))
      }

      this.filasSnapshot = JSON.parse(JSON.stringify(datosNormalizados))
      this.filasLocal = JSON.parse(JSON.stringify(datosNormalizados))
    },

    showInfo () {
      this.showDialogInfo = true
    },

    cerrarInfo () {
      this.showDialogInfo = false
    },

    onClickCargar () {
      if (this.$refs.fileInput) this.$refs.fileInput.click()
    },

    onChangeArchivo (e) {
      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (res) => {
        this.procesarFichero(res.target.result)
      }

      reader.readAsText(file)

      e.target.value = ''
    },

    procesarFichero (contenido) {
      const lineas = contenido.trim().split(/\r?\n/)
      const filasProcesadas = []
      const errores = []

      for (let i = 0; i < lineas.length; i++) {
        const linea = lineas[i].trim()
        if (!linea) continue

        const columnas = linea.split(/\s+/)

        if (columnas.length !== 6) {
          errores.push(`Línea ${i + 1}: Formato incorrecto. Se esperaban 6 columnas, encontradas ${columnas.length}.`)
          continue
        }

        const valoresRaw = columnas.map(v => v.replace(',', '.'))

        if (valoresRaw.some(v => isNaN(Number(v)))) {
          errores.push(`Línea ${i + 1}: Contiene valores que no son números.`)
          continue
        }

        const modeloId = parseInt(valoresRaw[0])
        const H1 = parseFloat(valoresRaw[1])
        const H10 = parseFloat(valoresRaw[2])
        const H100 = parseFloat(valoresRaw[3])
        const LIVE_H = parseFloat(valoresRaw[4])
        const LIVE_W = parseFloat(valoresRaw[5])

        if ([H1, H10, H100, LIVE_H, LIVE_W].some(val => val < 0 || val > 100)) {
          errores.push(`Línea ${i + 1}: Los valores deben ser porcentajes entre 0 y 100.`)
          continue
        }

        filasProcesadas.push({
          custom: modeloId > 13,
          FUEL_MODEL_TYPE: modeloId,
          H1,
          H10,
          H100,
          LIVE_H,
          LIVE_W
        })
      }

      if (errores.length > 0) {
        this.$notify({
          title: 'Error al leer el archivo',
          text: errores.slice(0, 5).join('\n') + (errores.length > 5 ? '\n...' : ''),
          type: 'error'
        })
        return
      }

      if (filasProcesadas.length > 0) {
        this.filasLocal = filasProcesadas
      } else {
        this.$notify({
          title: 'Error',
          text: 'El archivo está vacío o no contiene datos válidos.',
          type: 'error'
        })
      }
    },

    exportarModelos () {
      const lineas = this.filasLocal.map(fila => {
        const m = fila.FUEL_MODEL_TYPE
        const H1 = fila.H1 !== '' && fila.H1 !== null ? fila.H1 : 0
        const H10 = fila.H10 !== '' && fila.H10 !== null ? fila.H10 : 0
        const H100 = fila.H100 !== '' && fila.H100 !== null ? fila.H100 : 0
        const LIVE_H = fila.LIVE_H !== '' && fila.LIVE_H !== null ? fila.LIVE_H : 0
        const LIVE_W = fila.LIVE_W !== '' && fila.LIVE_W !== null ? fila.LIVE_W : 0

        return `${m} ${H1} ${H10} ${H100} ${LIVE_H} ${LIVE_W}`
      })

      const contenidoTexto = lineas.join('\n')

      const blob = new Blob([contenidoTexto], { type: 'text/plain;charset=utf-8' })
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'modelos_combustible.txt')

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
    },

    resetValores () {
      this.filasLocal = JSON.parse(JSON.stringify(this.filasSnapshot))
    },

    addFila () {
      const nextModelo = this.filasLocal.length > 0
        ? Math.max(...this.filasLocal.map(f => f.FUEL_MODEL_TYPE)) + 1
        : 0

      this.filasLocal.push({
        custom: true,
        FUEL_MODEL_TYPE: nextModelo,
        H1: '',
        H10: '',
        H100: '',
        LIVE_H: '',
        LIVE_W: ''
      })

      this.$nextTick(() => {
        const wrapper = this.$refs.tablaModelos?.$el.querySelector('.v-data-table__wrapper')

        if (wrapper) {
          wrapper.scrollTo({
            top: wrapper.scrollHeight,
            behavior: 'smooth'
          })
        }
      })
    },

    borrarFila (index) {
      this.filasLocal.splice(index, 1)
    },

    cancelar () {
      this.$emit('cancelar')
    },

    aceptar () {
      const hayErrores = this.filasLocal.some(fila => {
        return [fila.H1, fila.H10, fila.H100, fila.LIVE_H, fila.LIVE_W].some(val => val === '' || val === null)
      })

      if (hayErrores) {
        this.$notify({
          title: 'Error',
          text: 'Por favor, completa todos los campos marcados en rojo antes de aplicar.',
          type: 'error'
        })
        return
      }

      const filasDevolver = this.filasLocal.map(fila => {
        return {
          FUEL_MODEL_TYPE: parseInt(fila.FUEL_MODEL_TYPE),
          H1: parseFloat(fila.H1),
          H10: parseFloat(fila.H10),
          H100: parseFloat(fila.H100),
          LIVE_H: parseFloat(fila.LIVE_H),
          LIVE_W: parseFloat(fila.LIVE_W)
        }
      })

      this.$emit('aceptar', {
        tipo: this.edit,
        filas: filasDevolver,
        perfil: this.perfilSeleccionado
      })
    }
  }
}
</script>

<style scoped>
.dialog-modelos-card {
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  max-height: 120vh;
}
.btn-dialog-redondeado {
  border-radius: 999px;
  text-transform: none;
}

.modelos-table-wrapper {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 16px;
}

.grid-layout {
  display: grid;
  grid-template-columns: 80px repeat(5, 1fr) 40px;
  align-items: center;
  column-gap: 12px;
  width: 100%;
}

/* CSS HEADER DE LA TABLA */
.modelos-columns-header {
  flex: 0 0 auto;
  padding-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  padding-right: 24px;
}
.col-header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* CSS CUERPO DE LA TABLA */
.modelos-data-table {
  width: 100%;
}
.modelos-data-table ::v-deep table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.modelos-data-table ::v-deep tr.grid-layout {
  display: grid;
  background: white !important;
  padding-bottom: 8px;
  padding-top: 2px;
}

.modelos-data-table ::v-deep td {
  display: block;
  border-bottom: none !important;
  padding: 0 !important;
}

.campo-modelo ::v-deep .v-input__control {
  min-height: 32px;
}
.campo-modelo ::v-deep input {
  text-align: right;
  padding-right: 8px;
  color: rgba(0, 0, 0, 0.87) !important;
}

.campo-modelo.v-input--is-disabled ::v-deep input {
  color: rgba(0, 0, 0, 0.38) !important;
}

.campo-modelo ::v-deep fieldset {
  border-color: rgba(0, 0, 0, 0.24);
}

.campo-modelo.error--text ::v-deep fieldset {
  border-color: #ff5252 !important;
  border-width: 2px;
}

.modelos-data-table ::v-deep input[type='number']::-webkit-outer-spin-button,
.modelos-data-table ::v-deep input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.modelos-data-table ::v-deep input[type='number'] {
  -moz-appearance: textfield;
}

/* CSS SCROLLBAR */
.modelos-data-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
}
.modelos-data-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.modelos-data-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #00557947;
  border-radius: 4px;
}
.modelos-data-table ::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #00557947 transparent;
}

/* CSS FOOTER */
.modelos-footer-fixed {
  flex: 0 0 auto;
  background: #ffffff;
  padding: 8px 16px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.btn-equal-width {
  flex: 1 1 0;
}
</style>
